import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { FirmThemeBySlug } from '@/_types/models/firm';

export const getFirmThemeBySlug = async ({
  slug,
  alias,
}: APIRequest<{
  alias: string;
  slug?: string | null;
}>): APIResponsePromise<FirmThemeBySlug> =>
  await _callBackend(
    `/firms/get_firm_theme_by_slug?slug=${slug}&alias=${alias}`,
    'GET',
  );

export const downloadDropLinkDocument = async ({
  folderName,
  token,
}: APIRequest<{
  folderName: string;
}>): APIResponsePromise => {
  const response = await _callBackend(
    '/firms/download_drop_link_document',
    'POST',
    {
      folder_name: folderName,
    },
    token,
    { returnResponseAsIs: true },
  );

  const blob = await response.blob();
  const url = globalThis?.URL?.createObjectURL(blob);
  const downloadLink: HTMLAnchorElement = document.createElement('a');

  downloadLink.href = url;
  downloadLink.setAttribute('download', 'Drop Link.zip');
  document.body.appendChild(downloadLink);
  downloadLink.click();

  return response;
};
